import axios from "axios";
import { cachedLiveSuggestion, pivotApiUrl, rememberLiveSuggestion } from "../redux/live-suggestion/liveSuggestionSlice";

const MISS = "That daily call did not load.";
const CRYPTO = new Set(
  "BTC ETH SOL BNB XRP ADA DOGE AVAX DOT LINK LTC TRX ZEC PAXG RENDER XAUT PEPE SUI TON UNI AAVE NEAR ATOM FIL APT ARB OP INJ".split(
    " ",
  ),
);
const SKIP = new Set("THE AND FOR YOU HOW WHAT THIS THAT DAILY CHECK STOCK STOCKS WITH FROM INTO YOUR".split(" "));

export function stockTarget(text) {
  const raw = String(text || "").trim();
  if (!/^(?:analys(?:e|is)|check|daily)\b/i.test(raw) || /^price\b/i.test(raw)) return "";
  const body = raw.replace(/^(?:analys(?:e|is)|check|daily)\s+/i, "").trim();
  const ax = body.toUpperCase().match(/\b([A-Z]{1,6}\.AX)\b/);
  if (ax) return ax[1];
  const persian = body.match(/[\u0600-\u06FF\u200c]{2,}(?:\s+[\u0600-\u06FF\u200c]{2,}){0,2}/);
  if (persian) return persian[0];
  const jakarta = body.toUpperCase().match(/\b([A-Z]{1,6}\.JK)\b/);
  if (jakarta) return jakarta[1];
  const tokens = body.toUpperCase().match(/\b[A-Z]{1,5}\b/g) || [];
  return tokens.find((token) => !SKIP.has(token) && !CRYPTO.has(token)) || "";
}

export function stockDaily(symbol) {
  const cached = cachedLiveSuggestion(symbol, "1d");
  if (cached?.prediction) {
    return Promise.resolve(`${cached.symbol || symbol} daily pivot is ${cached.prediction}.`);
  }
  return axios
    .post(pivotApiUrl({ action: "inference", symbol, timeframe: "1d", exchange_id: "yahoo" }), {
      action: "inference",
      symbol,
      timeframe: "1d",
      exchange_id: "yahoo",
    })
    .then((res) => {
      const data = res?.data || {};
      if (data.miss === "no_model") {
        const stem = data.symbol || symbol;
        return axios.post(pivotApiUrl({ action: "request_train", symbol: stem, timeframe: "1d" }), {
          action: "request_train",
          symbol: stem,
        }).then((train) => {
          if (train?.data?.queued) {
            return "Training was requested. The daily call appears after that finishes.";
          }
          return train?.data?.message || MISS;
        });
      }
      if (data.prediction) {
        rememberLiveSuggestion({
          ...data,
          symbol: data.symbol || symbol,
          timeframe: "1d",
        });
        return `${data.symbol || symbol} daily pivot is ${data.prediction}.`;
      }
      return data.message || MISS;
    })
    .catch(() => MISS);
}
